<div class="card text-left h-100">
  <div class="card-header bg-light">
    <h4 class="card-title mb-0">{{ titulo }} Folha Teste</h4>
  </div>

  <div class="card-body wrapper m-0">
    <form class="needs-validation" novalidate id="myForm" #f="ngForm">
      <div class="row mt-2">

        <div class="col-sm-2">
          <label for="numeroOsa" class="form-label">Nº Osa</label>
          <input type="text" name="numeroOsa" class="form-control form-control-sm" id="numeroOsa" disabled
            placeholder="-" [(ngModel)]="numeroOsa" [ngModelOptions]="{standalone: true}" />
        </div>

        <div class="col-sm-2">
          <label for="nomeUG" class="form-label">UG. Auditada</label>
          <input type="text" name="nomeUG" class="form-control form-control-sm" id="nomeUG" disabled placeholder="-"
            [(ngModel)]="unidadeGestoraNome" [ngModelOptions]="{standalone: true}" />
        </div>

        <div class="col-sm-2">
          <label for="numeroFolha" class="form-label">Nº Folha Teste</label>
          <input type="text" name="numeroFolha" class="form-control form-control-sm" id="numeroFolha" disabled
            placeholder="-" [(ngModel)]="numeroFolha" [ngModelOptions]="{standalone: true}" />
        </div>

        <div class="col-sm-3">
          <label for="amostraItemDescricao" class="form-label">Item da Amostra</label>
          <input type="text" name="amostraItemDescricao" class="form-control form-control-sm" id="amostraItemDescricao"
            disabled placeholder="-" [(ngModel)]="amostraItemDescricao" [ngModelOptions]="{standalone: true}" />
        </div>

        <div class="col-sm-3">
          <label for="nomeAmostra" class="form-label">Amostra</label>
          <input type="text" name="nomeAmostra" class="form-control form-control-sm" id="nomeAmostra" disabled
            placeholder="-" [(ngModel)]="amostraNome" [ngModelOptions]="{standalone: true}" />
        </div>
      </div>

      <div class="row mt-2" *ngIf="dataSource?.data?.length >= 0">
        <div class="col-sm-12">
          <label class="form-label">Questões/Procedimentos</label>
          <div class="mat-elevation-z1">

            <table mat-table [dataSource]="dataSource" class="w-100" matSort matSortActive="ordem"
              matSortDirection="asc">

              <!-- Identificador -->
              <ng-container matColumnDef="identificador">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Identif.</th>
                <td mat-cell *matCellDef="let element">{{ element.identificador || '' }}</td>
              </ng-container>

              <!-- Descrição -->
              <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Questão/Procedimento</th>
                <td mat-cell *matCellDef="let element">
                  {{ getDescricaoQuestao(element) }}
                </td>
              </ng-container>

              <!-- Avaliação -->
              <ng-container matColumnDef="avaliacao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Avaliação</th>
                <td mat-cell *matCellDef="let element">{{ element.avaliacaoDesc || '' }}</td>
              </ng-container>

              <!-- Responsável -->
              <ng-container matColumnDef="responsavel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Responsável pela Última Alteração</th>
                <td mat-cell *matCellDef="let element">{{ element.responsavelNome || '' }}</td>
              </ng-container>

              <!-- Status -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="!element.status">-</span>
                  <span *ngIf="element.status === 1" class="badge bg-success text-xs">{{ element?.statusDesc }}</span>
                  <span *ngIf="element.status === 2" class="badge bg-warning text-xs">{{ element?.statusDesc }}</span>
                </td>
              </ng-container>

              <!-- Actions -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Ações</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex justify-content-center align-items-center">
                    <button type="button" class="btn btn-primary btn-xs ml-1" title="Responder" *ngIf="!visualizar"
                      (click)="modalResponder('Responder', false, element)">
                      <i class="fas fa-pen"></i>
                    </button>
                    <button type="button" class="btn btn-warning btn-xs ml-1" title="Histórico"
                      (click)="modalHistorico(element)">
                      <i class="fas fa-history"></i>
                    </button>
                    <button type="button" class="btn btn-info btn-xs ml-1" title="Visualizar"
                      (click)="modalResponder('Visualizar', true, element)">
                      <i class="far fas fa-eye"></i>
                    </button>
                  </div>
                </td>
              </ng-container>

              <!-- Header and Row -->
              <tr mat-header-row
                *matHeaderRowDef="['identificador', 'descricao', 'avaliacao', 'responsavel', 'status', 'actions']"></tr>
              <tr mat-row
                *matRowDef="let row; columns: ['identificador', 'descricao', 'avaliacao', 'responsavel', 'status', 'actions']">
              </tr>

            </table>

            <h5 class="table-no-data" [hidden]="dataSource?.data?.length > 0">
              Nenhum registro encontrado
            </h5>

            <!-- Paginador -->
            <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>

          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="card-footer">
    <div class="d-flex justify-content-between align-items-center">
      <div class="list2">
        <button type="button" class="btn btn-default btn-sm" (click)="fechar()">
          <i class="fas fa-times"></i> Fechar
        </button>
      </div>
    </div>
  </div>
</div>